export enum SegmentsAndListsIndices {
  SEGMENTS_INDEX = 'segments',
  LISTS_INDEX = 'lists',
  EMPTY_SEGMENTS_INDEX = 'empty_segments',
  EMPTY_LISTS_INDEX = 'empty_lists',
}
